<template>
    <div class="consulting">
        <div class="box">
            <div class="title">
                <p>业务咨询</p>
                <i class="close" @click="handleClose"></i>
            </div>
            <div class="form">
                <el-form ref="form" :model="form" :rules="rules" label-width="100px">
                    <el-form-item label="您的称呼:" prop="username">
                        <el-input v-model="form.username" maxlength="8" placeholder="请输入您的称呼"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式:" prop="phone">
                        <el-input v-model.trim="form.phone" maxlength="11" placeholder="请输入您的联系方式"></el-input>
                    </el-form-item>
                    <el-form-item label="咨询描述:" prop="consultDesc">
                        <el-input type="textarea" v-model="form.consultDesc" maxlength="200" placeholder="咨询描述"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码:" prop="verifyCode">
                        <el-input v-model="form.verifyCode" maxlength="8" placeholder="请输入验证码">
                            <img slot="append" :src="imgCodeUrl + '?loginCode=' + code" alt="" @click="getCodeToken">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm">提交</el-button>
                        <el-button @click="handleClose">取消</el-button>
                    </el-form-item>

                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
import { savePortalConsult, getLoginCode, imgCodeUrl } from '@/api/api'
export default {
    name: "",
    components: {},
    data() {
        let validatePhone = (rule, value, callback) => {
            if (value && !this.$public.phone(value)) {
                callback(new Error('请输入正确的联系方式'))
            }
            callback()
        }
        return {
            form: {
                username: '',
                consultDesc: '',
                phone: '',
                verifyCode: ''
            },
            rules: {
                username: [{ required: true, message: '请输入您的称呼', trigger: 'blur' }],
                phone: [{ required: true, message: '请输入您的联系方式', trigger: 'blur' }, { validator: validatePhone, trigger: 'blur' }],
                consultDesc: [{ required: true, message: '请输入咨询描述', trigger: 'blur' }],
                verifyCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
            imgCodeUrl,
            code: ''
        };
    },
    created() { },
    mounted() {
        this.getCodeToken()
    },
    methods: {
        handleClose() {
            this.$emit('close')
            this.$refs.form.resetFields();
            this.$refs.form.clearValidate();
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    let data = {
                        ...this.form,
                        loginCode: this.code
                    }
                    savePortalConsult(data).then(res => {
                        if (res.code === 0) {
                            this.$message.success('提交成功')
                            this.handleClose()
                        } else {
                            this.getCodeToken()
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        // 获取验证码
        getCodeToken() {
            getLoginCode().then(res => {
                if (res.code === 0) {
                    this.code = res.data
                }
            })
        }
    },
};
</script>

<style lang="less" scoped>
.consulting {
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);

    .box {
        width: 560px;
        height: 540px;
        background-color: #ffffff;
        border-radius: 6px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .title {
            padding: 18px 24px 18px 38px;
            border-bottom: 1px solid #e6e6e6;
            color: #23242e;
            position: relative;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &::before {
                content: "";
                width: 3px;
                height: 16px;
                background: #0055ff;
                position: absolute;
                left: 24px;
                top: 20px;
            }

            i {
                display: inline-block;
                width: 12px;
                height: 12px;
                background: url(../assets/icon_close.png);
                cursor: pointer;
            }
        }

        .form {
            padding: 30px 55px;
        }
    }
}

/deep/.el-form-item__label {
    font-size: 16px;
    font-weight: 400;
    color: #222222;
}

/deep/.el-form-item {
    margin-bottom: 30px;
}

/deep/.el-textarea__inner {
    height: 146px;
    border-radius: 2px;
}

/deep/.el-input__inner {
    border-radius: 2px;
}

/deep/.el-button {
    width: 166px;
    border-radius: 2px;
}

/deep/.el-button+.el-button {
    margin-left: 18px;
}

/deep/.el-input-group__append {
    padding: 2px 10px 0;
    background: transparent;
    cursor: pointer;
}
</style>
